export default "__VITE_ASSET__D913CwnE__"